const primitives = {
    bigint: BigInt(0),
    boolean: true,
    function: () => { },
    number: 0,
    object: {},
    string: '',
    symbol: Symbol(),
    undefined: undefined,
};
export const primitiveTypes = Object.keys(primitives);
export const isTypeOf = (...types) => (value) => types.includes(typeof value);
export const isNotTypeOf = (...types) => (value) => !types.includes(typeof value);
//# sourceMappingURL=primitives.js.map